"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _exchangeReactHooks = require("@mulesoft/exchange-react-hooks");
var _assets = require("@mulesoft/exchange-ui-portals-store/lib/domains/assets");
var _portals = require("@mulesoft/exchange-ui-portals-store/lib/domains/portals");
var _reactRedux = require("react-redux");
var _DocumentationButton = _interopRequireDefault(require("./DocumentationButton"));
var _routes = require("../../utils/routes");
var EditIcon = function EditIcon(props) {
  return /*#__PURE__*/_react.default.createElement("svg", props, /*#__PURE__*/_react.default.createElement("path", {
    d: "M14.728 2.88a3.013 3.013 0 0 1 4.257 0l2.133 2.13a3.005 3.005 0 0 1 0 4.254l-2.412 2.406-9.186 9.172a1 1 0 0 1-.526.276l-4.626.849a2.005 2.005 0 0 1-2.34-2.301l.77-4.613a1 1 0 0 1 .28-.543l9.239-9.223 2.41-2.407zM18 9.55l1.704-1.701a1.005 1.005 0 0 0 0-1.424l-2.132-2.13a1.014 1.014 0 0 0-1.431 0l-1.702 1.7L18 9.55zm-4.977-2.143L4.718 15.7 4 19.995v.002h.001l.003.003h.003l4.32-.793 8.258-8.244-3.562-3.556z"
  }));
};
EditIcon.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
var ViewIcon = function ViewIcon(props) {
  return /*#__PURE__*/_react.default.createElement("svg", props, /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.82 8.997C25.297 3.688 20.037 0 13.97 0 7.906 0 2.645 3.688.12 8.997c-.16.335-.16.727 0 1.006C2.645 15.312 7.906 19 13.97 19c6.067 0 11.327-3.688 13.85-8.997.161-.335.161-.67 0-1.006Zm-13.85-7.88c5.581 0 10.421 3.255 12.742 7.94a.941.941 0 0 1 0 .887c-2.32 4.684-7.16 7.938-12.741 7.938-5.581 0-10.421-3.254-12.742-7.938-.148-.247-.148-.592 0-.888C3.55 4.372 8.389 1.118 13.97 1.118Zm0 14.53a6.147 6.147 0 1 0 0-12.294 6.147 6.147 0 0 0 0 12.295Zm0-1.117a5.03 5.03 0 1 0 0-10.059 5.03 5.03 0 0 0 0 10.06Z"
  }));
};
ViewIcon.defaultProps = {
  viewBox: "0 0 28 19",
  xmlns: "http://www.w3.org/2000/svg"
};
var EditDocumentation = function EditDocumentation(_ref) {
  var _ref$hasUnpublishedCh = _ref.hasUnpublishedChanges,
    hasUnpublishedChanges = _ref$hasUnpublishedCh === void 0 ? false : _ref$hasUnpublishedCh,
    _ref$isPageComponent = _ref.isPageComponent,
    isPageComponent = _ref$isPageComponent === void 0 ? true : _ref$isPageComponent;
  var isLoading = (0, _reactRedux.useSelector)(_portals.selectors.isPortalLoading);
  var isDraft = (0, _exchangeReactHooks.useIsPortalDraft)();
  var getPath = (0, _exchangeReactHooks.useGetPath)();
  var config = (0, _exchangeReactHooks.useConfig)();
  var asset = (0, _exchangeReactHooks.useAsset)();
  var canEdit = (0, _reactRedux.useSelector)(function (state) {
    return _assets.selectors.canShowEdition(state, asset);
  });
  var editIcon = /*#__PURE__*/_react.default.createElement(EditIcon, null);
  var viewIcon = /*#__PURE__*/_react.default.createElement(ViewIcon, null);
  var pageParams = (0, _routes.getPageParams)(asset, config.defaultPageName);
  var editURL = getPath('pageEdit', pageParams);
  var pageDraftURL = getPath('pageDraft', pageParams);
  if (!isPageComponent || isDraft || isLoading || !canEdit) {
    return null;
  }
  return /*#__PURE__*/_react.default.createElement("div", {
    role: "group"
  }, !hasUnpublishedChanges ? /*#__PURE__*/_react.default.createElement(_DocumentationButton.default, {
    icon: editIcon,
    linkURL: editURL,
    testId: "edit-documentation",
    description: "Activate documentation editing mode",
    tooltipText: "Edit Documentation creating a draft"
  }, "Edit documentation") : null, hasUnpublishedChanges ? /*#__PURE__*/_react.default.createElement(_DocumentationButton.default, {
    icon: editIcon,
    linkURL: editURL,
    testId: "edit-draft",
    description: "Activate draft documentation editing mode"
  }, "Edit draft") : null, hasUnpublishedChanges ? /*#__PURE__*/_react.default.createElement(_DocumentationButton.default, {
    icon: viewIcon,
    linkURL: pageDraftURL,
    testId: "view-draft",
    description: "Activate draft documentation view mode"
  }, "View draft") : null);
};
var _default = exports.default = EditDocumentation;
//# sourceMappingURL=EditDocumentation.js.map